export enum BasketItemType {
	NotSet = 0,
	Ticket = 1,
	Service = 2,
	Product = 3,
	TicketingTrxFee = 4,
	Installment = 5,
}



// WEBPACK FOOTER //
// ./src/app/models/basket-item-type.enum.ts